export default {
  LOAD_CYCLE_THEORETICAL_PART_LIST_START: 'LoadCycleTheoreticalPartsListStart',
  LOAD_CYCLE_THEORETICAL_PART_LIST_END: 'LoadCycleTheoreticalPartsListEnd',
  TOGGLE_CYCLE_THEORETICAL_PART_LIST_CONFIRM_DIALOG: 'ToggleCycleTheoreticalPartListConfirmDialog'
};